import DropWord from './drop-word'
import {
  DEFAULT_WORD_LIST,
  POINTS_BY_WORD,
  TOOLBOX_CONFIG,
  TOOLBOX_INSTRUCTIONS_CONFIG,
  WORD_GRID_GAP_COLUMN,
  WORD_GRID_GAP_ROW,
} from './../constants/game'
import { pushEventData } from '../../utils/pushEventDataLayer'
export default class ToolBoxComponent {
  /** @type Phaser.GameObjects.Image */
  toolbox
  MEDIA_TYPE
  toolBoxConfig
  /** @type Array<Phaser.GameObjects.Image> */
  wordListComponents
  /**
   * @type {{
   *  context: Phaser.Scene,
   *  wordList: Array<{
   *    x: number,
   *    y: number,
   *    word: string,
   *    isLocked: boolean,
   *    lockedSrc: string,
   *    emptySrc: string,
   *    lockedSrcKey: string
   *    emptySrcKey: string
   *  }>
   *   handleOnSuccess: function
   * }}
   **/
  config = {}

  /**
   *
   * @param { Phaser.Scene } context
   * @param {Array<{
   *  x: number,
   *  y: number,
   *  word: string,
   *  isLocked: boolean,
   *  lockedSrc: string,
   *  emptySrc: string
   * }>} wordList
   * @param {function} handleOnSuccess
   */
  constructor(context, wordList = DEFAULT_WORD_LIST, handleOnSuccess) {
    this.config.context = context
    this.config.wordList = wordList
    this.handleOnSuccess = handleOnSuccess
  }

  // LOAD assets
  preload() {
    this.config.context.load.image(
      'word-shadow-particle',
      TOOLBOX_CONFIG.shadowParticle
    )
    this.config.wordList = this.config.wordList.map(wordItem => {
      //wordItem.emptySrcKey = `${this.config.context.scene.key}-${wordItem.word}-empty`
      //wordItem.lockedSrcKey = `${this.config.context.scene.key}-${wordItem.word}-locked`
      //this.config.context.load.image(wordItem.lockedSrcKey, wordItem.lockedSrc)
      //this.config.context.load.image(wordItem.emptySrcKey, wordItem.emptySrc)
      return wordItem
    })
  }

  create() {
    this.MINIMAP_CAM_ID = this.config.context.cameras.getCamera('minimap').id
    this.MEDIA_TYPE = this.config.context.data.get('mediaType')
    this.toolBoxConfig = {
      ...TOOLBOX_CONFIG,
      width: this.config.context.game.config.width,
      height: TOOLBOX_CONFIG.height[this.MEDIA_TYPE],
      posX: 0,
      posY:
        this.config.context.game.config.height -
        TOOLBOX_CONFIG.height[this.MEDIA_TYPE],
    }
    this.mainContainer = this.config.context.add.container(
      0,
      this.config.context.game.config.height - this.toolBoxConfig.height,
      []
    )
    this.mainContainer.default_y =
      this.config.context.game.config.height - this.toolBoxConfig.height
    this.mainContainer.setDepth(this.toolBoxConfig.depth)
    this.makeRectContainer()
    this.makeDropWords()
    this.makeInstructions()

    if (this.MEDIA_TYPE === 'mobile') {
      this.dropZoneForMobile()
    }

    //--
    window.$tbx = this
  }

  makeRectContainer = () => {
    this.toolbox = this.config.context.add
      .graphics({
        x: 0,
        y: 0,
      })
      .fillStyle(this.toolBoxConfig.fillColor, this.toolBoxConfig.fillOpacity)
      // neet that +300 for mobile
      .fillRect(
        0,
        0,
        this.toolBoxConfig.width,
        this.toolBoxConfig.height + this.config.context.game.scale.height
      )
      .setScrollFactor(0)
      .setDepth(this.toolBoxConfig.depth)
    this.toolbox.cameraFilter = this.MINIMAP_CAM_ID

    this.mainContainer.add(this.toolbox)
  }

  makeDropWords = () => {
    const SHOW_DEBUG_BORDER = false
    const PADDING_TOP = this.toolBoxConfig.paddingTop[this.MEDIA_TYPE]
    const PADDING_LEFT = this.toolBoxConfig.paddingLeft[this.MEDIA_TYPE]
    const PADDING_RIGHT = this.toolBoxConfig.paddingRight[this.MEDIA_TYPE]
    // this.config.context.game.config.height -
    // this.toolBoxConfig.height +
    // this.toolBoxConfig.paddingTop[this.MEDIA_TYPE];
    const totalwordstofind = this.config.wordList.length
    var wordsFound = 0

    // MAKE WORDS
    /** @type DropWord */
    let cursor = { x: 0, y: 0 }
    let fit_height = 0
    let fit_width = 0
    let finalRow = false
    // CONTAINER TO WORDS...
    this.wordsContainer = this.config.context.add.container(0, 0, [])
    this.mainContainer.add(this.wordsContainer)
    this.wordsContainer.setDepth(this.toolBoxConfig.depth)
    this.wordsContainer.cameraFilter = this.MINIMAP_CAM_ID
    this.wordsContainer.y = PADDING_TOP
    this.wordsContainer.x = PADDING_LEFT

    const MAX_WIDTH =
      this.config.context.game.config.width - PADDING_RIGHT - PADDING_LEFT

    this.wordListComponents = this.config.wordList.map((wordItem, index) => {
      let newWordItem = {
        ...wordItem,
        x: cursor.x,
        y: cursor.y,
      }

      const lastWord = new DropWord(this.config.context, newWordItem, index)

      /// --  [     ]

      this.wordsContainer.add(lastWord.word)
      if (fit_height === 0) {
        fit_height = lastWord.word.height * 0.5 + WORD_GRID_GAP_ROW
      }

      if (!finalRow && cursor.x + lastWord.word.width >= MAX_WIDTH) {
        const w_height = lastWord.word.height * 0.5 + WORD_GRID_GAP_ROW
        cursor.x = 0
        cursor.y += w_height

        lastWord.word.x = cursor.x
        lastWord.word.y = cursor.y
        fit_height += w_height
        if (this.MEDIA_TYPE === 'desktop') {
          // 2 rows max
          finalRow = true
        }
      }

      cursor.x += lastWord.word.width + WORD_GRID_GAP_COLUMN

      fit_width = Math.max(fit_width, cursor.x - WORD_GRID_GAP_COLUMN)
      return lastWord
    })

    this.wordsContainer.setSize(fit_width, fit_height)

    if (fit_width < MAX_WIDTH - PADDING_LEFT) {
      //this.MEDIA_TYPE === 'desltop'
      this.wordsContainer.x =
        PADDING_LEFT +
        (MAX_WIDTH - PADDING_LEFT) / 2 -
        (fit_width - WORD_GRID_GAP_ROW) / 2
    }

    if (SHOW_DEBUG_BORDER) {
      // BORDER WORD CONTAINER FOR DEBUG GRAPHIC
      const borderWordContainer = this.config.context.add.graphics()
      borderWordContainer
        .lineStyle(2, 0xfff000, 1)
        .strokeRoundedRect(
          0,
          0,
          this.wordsContainer.width,
          this.wordsContainer.height,
          2
        )
        .setScrollFactor(0)
        .setDepth(1).cameraFilter = this.MINIMAP_CAM_ID
      this.wordsContainer.add(borderWordContainer)

      this.mainContainer.add(
        this.config.context.add
          .graphics()
          .lineStyle(2, 0xff0000, 1)
          .strokeRoundedRect(
            MAX_WIDTH,
            PADDING_TOP,
            2,
            this.wordsContainer.height,
            2
          )
          .setScrollFactor(0)
          .setDepth(1)
      ).cameraFilter = this.MINIMAP_CAM_ID
    }

    // CEENTER WORDS CONTAINER

    this.config.context.input.on(
      'dragenter',
      (pointer, gameObject, dropZone) => {
        if (dropZone.data) {
          dropZone.data.set({ hover: true })
        }
      }
    )

    this.config.context.input.on(
      'dragleave',
      (pointer, gameObject, dropZone) => {
        if (dropZone.data) {
          dropZone.data.set({ hover: false })
        }
      }
    )
    this.config.context.input.on(
      'drop',
      (pointer, dragElement, dropZone) => {
        /** @type Phaser.GameObjects.Image */
        //dragElement
        /** @type Phaser.GameObjects.Zone */
        //dropZone
        if (!dropZone.data) {
          return
        }
        let dragWord = dragElement.data?.get('word')
        let dropWord = dropZone.data?.get('word')
        if (dragWord && dropWord && dragWord === dropWord) {
          dropZone.data.set({ isDropped: true })
          dragElement.data.set({ dropped: true })
          //_dragElement.destroy() u are not to tell me this
          let lastPoints = this.config.context.data.get('POINTS')
          this.config.context.data.set('POINTS', lastPoints + POINTS_BY_WORD)
          wordsFound++
          pushEventData({
            event: 'Juego ' + this.config.context.getRoomName(),
            action: 'click Juego',
            label: dragWord,
          })
          if (wordsFound >= totalwordstofind) {
            this.gameWinEvent()
          }
        } else {
          dropZone.data.set({ hover: false })
        }
      },
      this
    )
  }

  makeInstructions() {
    const isntructionsContainer = this.config.context.add.container(
      this.config.context.game.config.width / 2,
      -TOOLBOX_INSTRUCTIONS_CONFIG.marginBottom[this.MEDIA_TYPE],
      []
    )
    const maxwidth = Math.min(
      this.config.context.game.config.width * 0.8,
      TOOLBOX_INSTRUCTIONS_CONFIG.maxwidth
    )

    const labelInstructions = this.config.context.add
      .text(
        0,
        0,
        TOOLBOX_INSTRUCTIONS_CONFIG.text,
        TOOLBOX_INSTRUCTIONS_CONFIG.style[this.MEDIA_TYPE]
      )
      .setResolution(2)
      .setWordWrapWidth(
        maxwidth - TOOLBOX_INSTRUCTIONS_CONFIG.marginX
        // this.config.context.game.config.width -
        // TOOLBOX_INSTRUCTIONS_CONFIG.marginX
      )
      .setOrigin(0.5)
      .setScrollFactor(0)
      .setDepth(TOOLBOX_INSTRUCTIONS_CONFIG.depth + 1)

    labelInstructions.cameraFilter = this.MINIMAP_CAM_ID

    const INSTRUCTIONS_BORDER_CONFIG = {
      posX:
        labelInstructions.x -
        labelInstructions.width / 2 -
        TOOLBOX_INSTRUCTIONS_CONFIG.backgroundPadding.hor,
      posY:
        labelInstructions.y -
        labelInstructions.height / 2 -
        TOOLBOX_INSTRUCTIONS_CONFIG.backgroundPadding.ver,
      width:
        labelInstructions.width +
        TOOLBOX_INSTRUCTIONS_CONFIG.backgroundPadding.hor * 2,
      height:
        labelInstructions.height +
        TOOLBOX_INSTRUCTIONS_CONFIG.backgroundPadding.ver * 2,
      borderRadius: 20,
    }

    const g = this.config.context.add
      .graphics()
      .lineStyle(2, 0xc03480, 1)
      .fillStyle(0xffffff, 1)
      .fillRoundedRect(
        INSTRUCTIONS_BORDER_CONFIG.posX,
        INSTRUCTIONS_BORDER_CONFIG.posY,
        INSTRUCTIONS_BORDER_CONFIG.width,
        INSTRUCTIONS_BORDER_CONFIG.height,
        INSTRUCTIONS_BORDER_CONFIG.borderRadius
      )
      .strokeRoundedRect(
        INSTRUCTIONS_BORDER_CONFIG.posX,
        INSTRUCTIONS_BORDER_CONFIG.posY,
        INSTRUCTIONS_BORDER_CONFIG.width,
        INSTRUCTIONS_BORDER_CONFIG.height,
        INSTRUCTIONS_BORDER_CONFIG.borderRadius
      )
      .setScrollFactor(0)
      .setDepth(this.toolBoxConfig.depth)
    g.cameraFilter = this.MINIMAP_CAM_ID
    isntructionsContainer.add(g)
    isntructionsContainer.add(labelInstructions)

    this.mainContainer.add(isntructionsContainer)

    {
      /* isntructionsContainer.destroy() */

      this.config.context.tweens.add({
        targets: isntructionsContainer,
        alpha: 0,
        duration: 3000,
        delay: 5000,
        ease: 'SineOut',
        onComplete: () => {
          isntructionsContainer.destroy()
        },
      })
    }
  }

  dropZoneForMobile = () => {
    const default_miny = this.mainContainer.default_y - 100
    const game = this.config.context.game
    var minYZone = default_miny
    var is_down = true
    const tweensConfig = {
      targets: this.mainContainer,
      y: 0,
      duration: 500,
      ease: 'Elastic',
      easeParams: [0.4, 0.5],
    }

    const goUp = () => {
      is_down = false
      const bottomLine =
        game.scale.gameSize.height - this.wordsContainer.height - 200

      tweensConfig.y = Math.max(
        100,
        Math.min(this.mainContainer.default_y, bottomLine)
      )
      minYZone = tweensConfig.y - 50
      this.config.context.tweens.add(tweensConfig)
    }
    const goDown = () => {
      is_down = true
      minYZone = default_miny
      tweensConfig.y = this.mainContainer.default_y
      this.config.context.tweens.add(tweensConfig)
    }

    var dragging = false
    this.config.context.input.on(
      'drag',
      (pointer, _dragElement, dragX, dragY) => {
        let dragWord = _dragElement.data?.get('word')
        dragging = dragWord && true
        if (dragWord && pointer.y >= minYZone) {
          goUp()
        }
      }
    )
    this.config.context.input.on(
      'drop',
      (pointer, _dragElement, dragX, dragY) => {
        setTimeout(() => {
          goDown()
        }, 100)
      }
    )
    this.config.context.input.on('pointerup', pointer => {
      if (dragging && !is_down) {
        goDown()
        dragging = false
        return
      }
      if (pointer.y >= minYZone) {
        goUp()
      } else {
        goDown()
      }
      dragging = false
    })
  }

  gameWinEvent() {
    // WAITING THE LAST WORD ANIMATINO
    setTimeout(() => {
      this.wordListComponents.forEach(_wordComp => {
        _wordComp.blinkSuccess()
      })
    }, 800)
    this.handleOnSuccess()
  }
}
